import Article from "../components/Article/Article.js"


export default function Main() {
  return (
    <>
      <Article />
    </>
  );
}